export default {
  'user-info-title': 'Please enter your name and phone number.',
  'biz-info-title': 'Please enter company information.',
  'user-info-description': 'To confirm your identification required.',
  'biz-info-description': 'Required for tax payment.',
}
